/* eslint-disable */
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { keyframes } from '@mui/system';

/**
 * SkeletonGrid — Shimmer loading state matching the split sections layout.
 */

const shimmer = keyframes`
  0% { background-position: -200% 0; }
  100% { background-position: 200% 0; }
`;

const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(6px); }
  to { opacity: 1; transform: translateY(0); }
`;

const SkeletonGrid = () => {
    const renderSkeletonCard = (index) => (
        <Box
            key={index}
            sx={{
                position: 'relative',
                overflow: 'hidden',
                minHeight: '132px',
                borderRadius: '16px',
                background: 'rgba(255, 255, 255, 0.65)',
                border: '1px solid rgba(15, 23, 42, 0.05)',
                p: { xs: 2.25, md: 3 },
                display: 'flex',
                flexDirection: 'column',
                gap: 1.5,
                animation: `${fadeIn} 0.35s ease-out ${index * 0.03}s both`,
                boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.01)'
            }}
            aria-hidden="true"
        >
            {/* Top row: Name line and Icon placeholder */}
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Box
                    sx={{
                        width: '50%',
                        height: '11px',
                        borderRadius: '4px',
                        background:
                            'linear-gradient(90deg, rgba(148,163,184,0.06) 25%, rgba(148,163,184,0.12) 50%, rgba(148,163,184,0.06) 75%)',
                        backgroundSize: '200% 100%',
                        animation: `${shimmer} 1.8s ease-in-out infinite`,
                        animationDelay: `${index * 0.04}s`
                    }}
                />
                <Box
                    sx={{
                        width: 32,
                        height: 32,
                        borderRadius: '8px',
                        background:
                            'linear-gradient(90deg, rgba(148,163,184,0.06) 25%, rgba(148,163,184,0.12) 50%, rgba(148,163,184,0.06) 75%)',
                        backgroundSize: '200% 100%',
                        animation: `${shimmer} 1.8s ease-in-out infinite`,
                        animationDelay: `${index * 0.04 + 0.05}s`
                    }}
                />
            </Box>

            {/* Middle: Value placeholder */}
            <Box
                sx={{
                    mt: 'auto',
                    width: '65%',
                    height: '24px',
                    borderRadius: '6px',
                    background:
                        'linear-gradient(90deg, rgba(148,163,184,0.08) 25%, rgba(148,163,184,0.18) 50%, rgba(148,163,184,0.08) 75%)',
                    backgroundSize: '200% 100%',
                    animation: `${shimmer} 1.8s ease-in-out infinite`,
                    animationDelay: `${index * 0.04 + 0.1}s`
                }}
            />
        </Box>
    );

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: { xs: 4, md: 5 } }}>
            {/* Merchant Network Skeletons */}
            <Box>
                <Typography
                    variant="h6"
                    component="h2"
                    sx={{
                        fontWeight: 600,
                        fontSize: '13px',
                        color: 'text.secondary',
                        mb: 2,
                        textTransform: 'uppercase',
                        letterSpacing: '0.06em',
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                        userSelect: 'none'
                    }}
                >
                    Merchant Network
                    <Box sx={{ width: 6, height: 6, borderRadius: '50%', backgroundColor: 'rgba(148, 163, 184, 0.2)' }} />
                </Typography>
                <Box
                    sx={{
                        display: 'grid',
                        gridTemplateColumns: {
                            xs: '1fr',
                            sm: 'repeat(2, 1fr)',
                            md: 'repeat(3, 1fr)',
                            lg: 'repeat(4, 1fr)'
                        },
                        gap: { xs: '16px', md: '20px' },
                        width: '100%'
                    }}
                >
                    {Array.from({ length: 7 }, (_, i) => renderSkeletonCard(i))}
                </Box>
            </Box>

            {/* Transaction Activity Skeletons */}
            <Box>
                <Typography
                    variant="h6"
                    component="h2"
                    sx={{
                        fontWeight: 600,
                        fontSize: '13px',
                        color: 'text.secondary',
                        mb: 2,
                        textTransform: 'uppercase',
                        letterSpacing: '0.06em',
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                        userSelect: 'none'
                    }}
                >
                    Transaction Activity
                    <Box sx={{ width: 6, height: 6, borderRadius: '50%', backgroundColor: 'rgba(148, 163, 184, 0.2)' }} />
                </Typography>
                <Box
                    sx={{
                        display: 'grid',
                        gridTemplateColumns: {
                            xs: '1fr',
                            sm: 'repeat(2, 1fr)',
                            md: 'repeat(3, 1fr)',
                            lg: 'repeat(4, 1fr)'
                        },
                        gap: { xs: '16px', md: '20px' },
                        width: '100%'
                    }}
                >
                    {Array.from({ length: 8 }, (_, i) => renderSkeletonCard(7 + i))}
                </Box>
            </Box>
        </Box>
    );
};

export default SkeletonGrid;
